import base from './base.repository'

export default {
    ...base,
    getItems(filters, page) {
        const params = { ...filters, page: page }
        this.get(`items${this.querify(params)}`)
        return this
    },
    getAvailableItems(filters, page) {
        const params = { ...filters, page: page }
        this.get(`items/availables${this.querify(params)}`)
        return this
    },
    saveItem(payload) {
        this.post('items', payload)
        return this
    },
    updateItem(payload, id) {
        this.put('items/' + id, payload)
        return this
    },
    deleteItem(id) {
        this.delete(`items/${id}`)
        return this
    },
    assignStructure(payload) {
        this.post('items/assign-structure', payload)
        return this
    },
    unassignStructure(id) {
        this.post('items/' + id + '/unassign-structure')
        return this
    },
    getItemTypes(page, sortBy, sortDir) {
        this.get(`item-types?page=${page}&sortBy=${sortBy}&sortDir=${sortDir}`)
        return this
    },
    saveItemType(payload) {
        this.post('items/item-type', payload)
        return this
    },
    updateItemType(payload, id) {
        this.put('items/item-type/' + id, payload)
        return this
    },
    deleteItemType(typeId) {
        this.delete(`items/item-type/${typeId}`)
        return this
    },
    getItemSubTypes(page, filters) {
        const params = { ...filters, page: page }
        this.get(`items/item-sub-types${this.querify(params)}`)
        return this
    },
    getItemSubTypesByItemType(itemTypeId) {
        this.get(`items/item-sub-types?type=${itemTypeId}`)
        return this
    },
    saveItemSubType(payload) {
        this.post('items/item-sub-type', payload)
        return this
    },
    updateItemSubType(payload, id) {
        this.put('items/item-sub-type/' + id, payload)
        return this
    },
    deleteItemSubType(subTypeId) {
        this.delete(`items/item-sub-type/${subTypeId}`)
        return this
    },
}
